export default "__VITE_ASSET__DSNElhjA__"